import React, { useEffect, useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { api } from "../../../services/api";
import useEventoStore from "../../../stores/useEventoStore";
import EventoForm from "../../../components/evento/EventoForm";
import EliminarEventoDialog from "../../../components/evento/EliminarEventoDialog";
import { fromEvento } from "../../../domain/evento/payload";
import { MODO_EDITAR } from "../../../domain/evento/schema";
import "./evento.css";
import "./event.css";

const EditEvent = () => {
  const { id } = useParams();
  const history = useHistory();
  const [t] = useTranslation("global");

  const [valoresIniciales, setValoresIniciales] = useState(null);
  const [nombreEvento, setNombreEvento] = useState("");
  const [mostrarEliminar, setMostrarEliminar] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title = "Editar Evento | PassGo";

    let cancelado = false;
    const cargar = async () => {
      try {
        const data = await useEventoStore.getState().fetchEvento(id);
        if (cancelado) return;

        if (!data?.evento) {
          setError("No se pudo cargar el evento.");
          return;
        }

        setNombreEvento(data.evento.evento);
        setValoresIniciales(fromEvento(data.evento));
      } catch (err) {
        if (!cancelado) {
          console.error("Error fetching event data:", err);
          setError("No se pudo cargar el evento.");
        }
      }
    };

    cargar();
    return () => {
      cancelado = true;
    };
  }, [id]);

  const guardar = async (payload) => {
    try {
      const response = await api.eventos.setEvento(id, payload);

      if (response.status !== "success") {
        // el backend manda el motivo listo para mostrar (ej: fechas con
        // tarifas asociadas), así que no se pisa con un texto genérico
        toast.error(response.message || "No se pudieron guardar los cambios.", {
          autoClose: 6000,
        });
        return;
      }

      toast.success("Los cambios se guardaron correctamente.");
      // se invalida la caché para que el resto de la app vea los cambios, pero
      // la edición no navega: sacar al usuario del evento que está editando lo
      // obliga a volver a entrar para seguir tocando cosas
      useEventoStore.getState().invalidar(id);
      setNombreEvento(payload.evento.evento);
    } catch (err) {
      console.error("Error submitting form:", err);
      toast.error("No se pudo conectar con el servidor.");
    }
  };

  if (error) {
    return <div className="container-evento p-4">{error}</div>;
  }

  if (!valoresIniciales) {
    return (
      <div className="container-evento d-flex justify-content-center p-5">
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="container-evento">
      <EventoForm
        modo={MODO_EDITAR}
        valoresIniciales={valoresIniciales}
        onSubmit={guardar}
        textoSubmit="Guardar cambios"
      >
        <Button
          type="button"
          sx={{ color: "red", border: "1px solid red", padding: "5px 15px" }}
          onClick={() => setMostrarEliminar(true)}
        >
          {t("event.deleteEvent")}
        </Button>
      </EventoForm>

      <EliminarEventoDialog
        abierto={mostrarEliminar}
        onClose={() => setMostrarEliminar(false)}
        eventoId={id}
        nombreEvento={nombreEvento}
        onEliminado={() => history.push("/eventos")}
      />
    </div>
  );
};

export default EditEvent;
